/*
 * @Description: 销售数据
 * @Author: Ray.Liang
 * @Date: 2022-11-22 15:59:46
 * @LastEditors:  Ray.Liang
 * @LastEditTime: 2022-11-22 15:59:46
 */
import axiosConfig from '@/sso/axios-config'
import axios from 'axios'
import { filterParameters } from '../util/common'

export async function querySaleList(condition) {
  //拆分开始时间
  if (condition.bookingTime != null && condition.bookingTime.length > 0) {
    condition.timeStart = condition.bookingTime[0]
    condition.timeEnd = condition.bookingTime[1]
  } else {
    condition.timeStart = null
    condition.timeEnd = null
  }

  var copyData = filterParameters(condition)
  delete copyData['bookingTime']
  return await axiosConfig.service({
    url: '/sale/search',
    method: 'post',
    data: { condition: copyData },
  })
}

export async function downloadSaleList(condition, type) {
  //拆分开始时间
  if (condition.bookingTime != null && condition.bookingTime.length > 0) {
    condition.timeStart = condition.bookingTime[0]
    condition.timeEnd = condition.bookingTime[1]
  } else {
    condition.timeStart = null
    condition.timeEnd = null
  }
  var copyData = filterParameters(condition)
  delete copyData['bookingTime']

  let requestData = {
    condition: copyData,
    type: type,
  }

  let str = encodeURI(JSON.stringify(requestData))

  // 开始请求后台
  axios
    .get('/manage/sale/download?data=' + str, {
      responseType: 'blob',
    })
    .then((res) => {
      if (!res) return

      console.log('res data = ' + res.data)
      // 文件类型
      let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
      console.log(res.headers['content-disposition'])
      // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment;filename=" + fileName + ".xlsx") 设置的文件名;
      //以=分割取数组[1]元素为文件名
      let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1])
      // 创建下载链接
      let url = window.URL.createObjectURL(blob)
      // 赋值给a标签的href属性
      let aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = url
      aLink.setAttribute('download', filename)
      // 将a标签挂载上去
      document.body.appendChild(aLink)
      // a标签click事件
      aLink.click()
      // 移除a标签
      document.body.removeChild(aLink)
      // 销毁下载链接
      window.URL.revokeObjectURL(url)
    })
    .catch(function(error) {
      console.log(error)
    })
}
